import { Command } from './Command';
import { ungroupObject, groupObjects } from '../components/Editor/utils/groupUtils';

/**
 * UngroupObjectsCommand - Dissolves a fabric.Group into individual canvas objects.
 *
 * execute(): Removes the group, restores individual objects with original positions.
 * undo():    Re-groups the extracted objects.
 *
 * @example
 * const cmd = new UngroupObjectsCommand(canvas, activeGroup);
 * commandStack.execute(cmd);
 */
export class UngroupObjectsCommand extends Command {
  /**
   * @param {fabric.Canvas} canvas
   * @param {fabric.Group} group - The group to dissolve
   */
  constructor(canvas, group) {
    super();
    this.canvas = canvas;
    this.group = group;
    this.extractedObjects = null;
  }

  execute() {
    const result = ungroupObject(this.canvas, this.group);
    if (result) {
      this.extractedObjects = result.objects;
    }
  }

  undo() {
    if (this.extractedObjects) {
      const result = groupObjects(this.canvas, this.extractedObjects);
      if (result) {
        this.group = result.group;
      }
    }
  }

  getDescription() {
    return 'Gruppierung lösen';
  }
}
